// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3v31B","placeholdersHeader":"styles_placeholdersHeader__3VS5-","editorStyle":"styles_editorStyle__uavdL","placeholdersBox":"styles_placeholdersBox__1g1DN"};